class CheckboxTab {
    constructor(el) {
        el.$controller = this;
        this.el = el;

        this.inputs = el.querySelectorAll('input');
        this.inputsOnce = el.querySelectorAll('input[data-once]');

        this.inputs.forEach((input) => {
           input.addEventListener('change', () => {
               if(!input.checked) return;

               if(input.dataset.once) {
                   this.inputs.forEach((inputOther) => {
                       if(inputOther.checked && inputOther !== input) {
                           console.log(inputOther, input);
                           inputOther.checked = false;
                           inputOther.dispatchEvent(new CustomEvent('change'));
                       }
                   });
               }
               else {
                   this.inputsOnce.forEach((inputOther) => {
                       if(inputOther.checked) {
                           inputOther.checked = false;
                           inputOther.dispatchEvent(new CustomEvent('change'));
                       }
                   });
               }
           });
        });
    }

    getValues() {
        const inputs = Array.from(this.el.querySelectorAll(':checked'));
        return inputs.map(input => input.value);
    }

    getValue() {
        return this.el.querySelector(':checked').value;
    }

}

document.querySelectorAll('.CheckboxTab').forEach(CheckboxTabInit)
function CheckboxTabInit(el) {
    checkInit(el, () => {
        new CheckboxTab(el);
    });
}
